import { equals } from 'ramda';

import { modifyJsonQuery, TModifier } from '../../../packages/Filters';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { getAvailableSpecialPromo } from '../../utils/specialPromos';
import { EFiltersActionType, IJsonQueryChanged } from './types';

const changeJsonQueryRaw = actionGenerator<EFiltersActionType.JsonQueryChanged, IJsonQueryChanged>(
  EFiltersActionType.JsonQueryChanged,
);

export function changeJsonQuery(payloadRaw: IJsonQueryChanged): TThunkAction {
  return (dispatch, getState) => {
    let payload = { ...payloadRaw };

    const { prevJsonQuery, nextJsonQuery } = payload;
    const { specialPromos } = getState();

    if (!equals(prevJsonQuery.region, nextJsonQuery.region)) {
      const prevSpecialPromo = getAvailableSpecialPromo(specialPromos, prevJsonQuery);
      if (prevSpecialPromo) {
        const isSpecialPromoActive =
          prevJsonQuery.geo && prevSpecialPromo
            ? prevJsonQuery.geo.value.some(
                value => value.type === 'builder' && value.id === prevSpecialPromo.developerId,
              )
            : null;

        if (isSpecialPromoActive) {
          const nextSpecialPromo = getAvailableSpecialPromo(specialPromos, nextJsonQuery);

          if (!equals(prevSpecialPromo, nextSpecialPromo)) {
            const modifier: TModifier = {
              action: 'removeGeo',
              arguments: [{ type: 'builder', id: prevSpecialPromo.developerId }],
            };

            payload.appliedModifiers.push(modifier);
            payload.nextJsonQuery = modifyJsonQuery(payload.nextJsonQuery, [modifier]);
          }
        }
      }
    }

    dispatch(changeJsonQueryRaw(payload));
  };
}
